import { FieldTypes, BelongsCreatedByRefField, emailField } from 'drapcode-constant';

const { date, createdBy, number } = FieldTypes;

export const prepareFieldOptions = (fields, collections) => {
  fields = fields
    .filter((field) => [date.id, number.id].includes(field.type))
    .map((field) => ({ label: field.fieldTitle.en, value: field.fieldName }));
  return fields;
};

export const prepareUserEmailFieldOptions = (fields, collections) => {
  const selfFields = fields
    .filter((field) => emailField.includes(field.type))
    .map((field) => {
      return {
        fieldName: field.fieldName,
        fieldTitle: field.fieldTitle.en,
      };
    });
  let nestedFields = getInnerFieldOptions(fields, collections);
  return [...selfFields, ...nestedFields].map((field) => ({
    label: field.fieldTitle,
    value: field.fieldName,
  }));
};

export const getInnerFieldOptions = (fields, collections) => {
  let nestedFields = [];
  const referenceFields = fields
    ? fields.filter((field) => BelongsCreatedByRefField.includes(field.type))
    : [];
  if (referenceFields.length > 0) {
    referenceFields.map((field) => {
      if (field.type === createdBy.id && !field.refCollection) {
        field.refCollection = {
          collectionName: 'user',
          collectionField: 'userName',
          displayType: 'dropdown',
        };
      }
      let { collectionName } = field.refCollection;
      let refFields = [];

      const refrenceCollection = collections
        ? collections.find((e) => e.collectionName === collectionName)
        : null;

      refFields =
        refrenceCollection && refrenceCollection.fields
          ? refrenceCollection.fields
              .filter((e) => emailField.includes(e.type))
              .map((nestedField) => {
                return {
                  fieldName: field.fieldName + '.' + nestedField.fieldName,
                  fieldTitle: field.fieldTitle.en + ':' + nestedField.fieldTitle.en,
                };
              })
          : [];
      nestedFields = [...nestedFields, ...refFields];
    });
  }
  return nestedFields;
};
